<template>
    <div class="component-group-list gap-lg flex w-full flex-col">
        <p class="max-w-4xl text-sm text-gray-300">
            Paste raw Atlassian Document Format JSON as received in support request details.
        </p>
        <div class="flex w-full max-w-4xl flex-col gap-lg xl:flex-row">
            <label class="flex min-w-0 flex-1 flex-col gap-sm">
                <span class="font-semibold">ADF Input</span>
                <textarea
                    v-model="adfPreviewInput"
                    class="min-h-[32rem] w-full rounded-sm border border-gray-100 bg-white p-md font-mono text-sm leading-6"
                ></textarea>
            </label>
            <div class="flex min-w-0 flex-1 flex-col gap-sm">
                <span class="font-semibold">Preview</span>
                <div class="min-h-[32rem] rounded-sm border border-gray-100 bg-white p-lg">
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                        v-if="adfPreview.renderAsHtml"
                        class="comment-body"
                        v-html="adfPreview.text"
                    ></div>
                    <!-- eslint-enable vue/no-v-html -->
                    <p v-else-if="adfPreview.text" class="comment-body whitespace-pre-wrap">
                        {{ adfPreview.text }}
                    </p>
                    <p v-else class="comment-body whitespace-pre-wrap text-gray-300">
                        No preview available.
                    </p>
                </div>
                <p v-if="adfPreviewError" class="text-sm text-error">
                    {{ adfPreviewError }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { isAdfDocument, resolveAdfRichTextValue } from '@/lib/adf-renderer';

const adfPreviewInput = ref(`{
  "type": "doc",
  "version": 1,
  "content": [
    {
      "type": "heading",
      "attrs": {
        "level": 2
      },
      "content": [
        {
          "type": "text",
          "text": "Hey "
        },
        {
          "type": "text",
          "text": "atNorth",
          "marks": [
            {
              "type": "strong"
            }
          ]
        }
      ]
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "Here is a new "
        },
        {
          "type": "text",
          "text": "Dedicated Server Order: asdf",
          "marks": [
            {
              "type": "strong"
            }
          ]
        }
      ]
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "Below is the "
        },
        {
          "type": "text",
          "text": "asdf",
          "marks": [
            {
              "type": "strong"
            }
          ]
        },
        {
          "type": "text",
          "text": " of the server node:"
        }
      ]
    },
    {
      "type": "blockquote",
      "content": [
        {
          "type": "paragraph",
          "content": [
            {
              "type": "text",
              "text": "ASDF: asfd"
            },
            {
              "type": "hardBreak"
            },
            {
              "type": "text",
              "text": "ASDF: asdf"
            },
            {
              "type": "hardBreak"
            },
            {
              "type": "text",
              "text": "asdf"
            }
          ]
        }
      ]
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "Please fill in the following information when delivering the server:"
        }
      ]
    },
    {
      "type": "panel",
      "content": [
        {
          "type": "paragraph",
          "content": [
            {
              "type": "text",
              "text": "asdf Access IP:"
            }
          ]
        },
        {
          "type": "bulletList",
          "content": [
            {
              "type": "listItem",
              "content": [
                {
                  "type": "paragraph",
                  "content": [
                    {
                      "type": "text",
                      "text": "Root User"
                    }
                  ]
                }
              ]
            },
            {
              "type": "listItem",
              "content": [
                {
                  "type": "paragraph",
                  "content": [
                    {
                      "type": "text",
                      "text": "Root Password"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "attrs": {
        "panelType": "info"
      }
    },
    {
      "type": "rule"
    },
    {
      "type": "panel",
      "content": [
        {
          "type": "paragraph",
          "content": [
            {
              "type": "text",
              "text": "The Hostname for this order should be setup as ("
            },
            {
              "type": "text",
              "text": "asdf",
              "marks": [
                {
                  "type": "strong"
                }
              ]
            },
            {
              "type": "text",
              "text": ")"
            }
          ]
        },
        {
          "type": "paragraph",
          "content": [
            {
              "type": "text",
              "text": "Please note that we asdfe! Should there be any reason for delay, please let us know as soon as possible!"
            }
          ]
        }
      ],
      "attrs": {
        "panelType": "note"
      }
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "Asdf '"
        },
        {
          "type": "text",
          "text": "In Use",
          "marks": [
            {
              "type": "strong"
            }
          ]
        },
        {
          "type": "text",
          "text": "' for the correct Asset Tag in the "
        },
        {
          "type": "text",
          "text": "Google Sheet",
          "marks": [
            {
              "type": "link",
              "attrs": {
                "href": "https://docs.google.com/spreadsheets/d/asdf/"
              }
            }
          ]
        }
      ]
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "It's asdf",
          "marks": [
            {
              "type": "strong"
            }
          ]
        }
      ]
    },
    {
      "type": "paragraph",
      "content": [
        {
          "type": "text",
          "text": "Best greetings,"
        }
      ]
    },
    {
      "type": "bulletList",
      "content": [
        {
          "type": "listItem",
          "content": [
            {
              "type": "paragraph",
              "content": [
                {
                  "type": "text",
                  "text": "Test"
                },
                {
                  "type": "hardBreak"
                },
                {
                  "type": "text",
                  "text": "asdf - 'asdf'"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}`);

const adfPreview = computed(() => resolveAdfRichTextValue(adfPreviewInput.value) ?? { text: '', renderAsHtml: false });

const adfPreviewError = computed(() => {
    const trimmed = adfPreviewInput.value.trim();
    if (!trimmed) return '';

    try {
        const parsed = JSON.parse(trimmed);
        return isAdfDocument(parsed) ? '' : 'Input is valid JSON, but it is not an ADF document.';
    } catch {
        return 'Input is not valid JSON.';
    }
});
</script>
